import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { STATES, TIME_ZONES } from 'src/app/core/constants/constants';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { UserService } from 'src/app/core/services/user/user.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-signup',
	templateUrl: './signup.component.html',
	styleUrls: ['./signup.component.scss'],
})
export class SignupComponent implements OnInit {
	// Login Form
	SignupForm!: FormGroup;
	submitted = false;
	successmsg = false;
	states = STATES;
	timezones = TIME_ZONES;
	error = '';
	// set the current year
	year: number = new Date().getFullYear();
	// Carousel navigation arrow show
	showNavigationArrows: any;
	fieldTextType!: boolean;
	messageError: string = '';
	loading: boolean = false;

	constructor(private formBuilder: FormBuilder, private route: ActivatedRoute, private userSrv: UserService, private router: Router, private authenticationSrv: AuthenticationService,) {}

	ngOnInit(): void {
		/**
		 * Form Validatyion
		 */
		this.SignupForm = this.formBuilder.group({
			firstName: ['', [Validators.required, Validators.minLength(2)]],
			lastName: ['', [Validators.required, Validators.minLength(2)]],
			companyName: ['', [Validators.required]],
			email: [{ value: '', disabled: true }, [Validators.required, Validators.email]],
			mobilePhone: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
			address: ['', [Validators.required]],
			timezone: ['', [Validators.required]],
			city: ['', [Validators.required]],
			state: ['', [Validators.required]],
			zipCode: ['', [Validators.required, Validators.pattern('^[0-9]{5}(?:-[0-9]{4})?$')]],
			password: ['', [Validators.required, Validators.minLength(8), Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]{8,}$')]],
		});

		this.SignupForm?.get('email')?.setValue(this.route.snapshot.params['email']);

		// Password Validation set
		var myInput = document.getElementById('password-input') as HTMLInputElement;
		var letter = document.getElementById('pass-lower');
		var capital = document.getElementById('pass-upper');
		var number = document.getElementById('pass-number');
		var length = document.getElementById('pass-length');

		// When the user starts to type something inside the password field
		myInput.onkeyup = function () {
			// Validate lowercase letters
			var lowerCaseLetters = /[a-z]/g;
			if (myInput.value.match(lowerCaseLetters)) {
				letter?.classList.remove('invalid');
				letter?.classList.add('valid');
			} else {
				letter?.classList.remove('valid');
				letter?.classList.add('invalid');
			}

			// Validate capital letters
			var upperCaseLetters = /[A-Z]/g;
			if (myInput.value.match(upperCaseLetters)) {
				capital?.classList.remove('invalid');
				capital?.classList.add('valid');
			} else {
				capital?.classList.remove('valid');
				capital?.classList.add('invalid');
			}

			// Validate numbers
			var numbers = /[0-9]/g;
			if (myInput.value.match(numbers)) {
				number?.classList.remove('invalid');
				number?.classList.add('valid');
			} else {
				number?.classList.remove('valid');
				number?.classList.add('invalid');
			}

			// Validate length
			if (myInput.value.length >= 8) {
				length?.classList.remove('invalid');
				length?.classList.add('valid');
			} else {
				length?.classList.remove('valid');
				length?.classList.add('invalid');
			}
		};
	}

	// convenience getter for easy access to form fields
	get f() {
		return this.SignupForm.controls;
	}

	saveUser() {
		this.loading = true;
		this.submitted = true;
		if (this.SignupForm.invalid) {
			console.error('Formulario inválido', this.SignupForm.value);
			return;
		}
		const payload = {
			...this.SignupForm.value,
			email: this.route.snapshot.params['email'],
		};

		this.userSrv.autoSignUp(payload).subscribe(
			(res: any) => {
				this.authenticationSrv.getLmsUserData(this.f['email'].value).subscribe((userData: any) => {
					if (userData != null) {
						this.authenticationSrv.register(this.f['email'].value, this.f['password'].value).then((res: any) => {
							this.loading = false;
							Swal.fire({
								title: 'Success registration',
								text: 'Do you want to login?',
								icon: 'success',
								confirmButtonText: 'Login',
								showCancelButton: true,
								cancelButtonText: 'No',
							}).then((result) => {
								if (result.isConfirmed) {
									this.router.navigate(['']);
								}
							});

						}).catch((error: any) => {
							console.error(error);
							Swal.fire({
								title: 'Error registration',
								text: error,
								icon: 'error',
								confirmButtonText: 'Ok',
							});
						});
					} else {
						this.messageError = 'The email that you have entered is not valid for the system. Please contact with support area support@lmsleads.com  or to the follow phone 877-265-8177.';
					}
				});
			},
			(error) => {
				console.error('Error en el registro:', error);
				this.messageError = error.error.message;
			}
		);
	}

	/**
	 * Password Hide/Show
	 */
	toggleFieldTextType() {
		this.fieldTextType = !this.fieldTextType;
	}

	validateField(field: string) {
		const control = this.SignupForm.get(field);
		if (control && control.invalid && (control.dirty || control.touched)) {
			control.markAsTouched();
		}
	}
}
